import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ImageNode } from '../components/editor/ImageNode';

export const CustomImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      'data-alignment': {
        default: 'center',
        parseHTML: element => element.getAttribute('data-alignment'),
        renderHTML: attributes => {
          return {
            'data-alignment': attributes['data-alignment']
          };
        }
      },
      'data-id': {
        default: null,
        parseHTML: element => element.getAttribute('data-id'),
        renderHTML: attributes => {
          if (!attributes['data-id']) return {};
          return {
            'data-id': attributes['data-id']
          };
        }
      },
      width: {
        default: null,
        parseHTML: element => element.getAttribute('width'),
        renderHTML: attributes => {
          if (!attributes.width) return {};
          return {
            width: attributes.width
          };
        }
      }
    };
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(ImageNode);
  }
});